import * as React from "react";
import { Text, TextProps } from "./text";

export type HeadingProps = TextProps & {
  as?: "h1" | "h2" | "h3" | "span";
  variant?: "h1" | "h2" | "h3";
};

const Heading = ({
  as = "h2",
  variant = as === "span" ? "h3" : as,
  ...props
}: HeadingProps) => {
  return <Text as={as} variant={variant} {...props} />;
};

export { Heading };
